import React, { createContext } from 'react';

import useQuery from './hooks/useQuery';

const Context = createContext({ params: {} });

function QueryParamsProvider({ children }) {
  const params = useQuery();

  return <Context.Provider value={params}>{children}</Context.Provider>;
}

export { Context, QueryParamsProvider };
